import React, {useContext} from "react";

// Components
import {renderInfoCardAction} from "../Layouts/Content/InfoCardActions";

// Context
import {GlobalInterfaceContext} from "../../Context/GlobalInterfaceContext";

type NotificationBarProps = {
    isDarkMode: boolean;
};

const NotificationBar: React.FC<NotificationBarProps> = ({ isDarkMode }) => {
    const {notificationBar} = useContext(GlobalInterfaceContext);
    const firstAction = notificationBar?.actions
        ? [...notificationBar.actions].sort((a, b) => a.sortOrder - b.sortOrder)[0]
        : undefined;

    return (
        <div
            className={`global__notification-bar u-relative_hidden ${isDarkMode ? 'is-dark-mode' : 'has-light-mode'}`}
        >
            {notificationBar && notificationBar.infoCardId && (
                <div className="notification-bar__content">
                    <p>
                        {notificationBar.heading}
                    </p>

                    {firstAction
                        ? renderInfoCardAction(firstAction, `${notificationBar.infoCardId}-notification-bar`)
                        : null}
                </div>
            )}

            <div className="u-full_cover_absolute" />
        </div>
    );
};

export default NotificationBar;
